import { Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ShimmerFragmentComponent } from '../../../fragment/shimmer-fragment.component';
import { SchedulingModalityEnum } from '@core/enums';

@Component({
  selector: 'agenda-customer-ui-driver-loading',
  standalone: true,
  imports: [CommonModule, ShimmerFragmentComponent],
  templateUrl: './driver-loading.component.html',
  styleUrls: ['./driver-loading.component.scss'],
})
export class DriverLoadingComponent {
  modalitySchedule = input.required<string>();
  modalityEnum = SchedulingModalityEnum;
}
